import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "./tailwind.css";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./state/store.ts";
import { DISPATCHES } from "./InterfacesTypes/enums.ts";
import { TextSizeApplier } from "components/TextSizeComponent/TextSizeApplier.tsx";
store.dispatch({ type: DISPATCHES.INITIALIZE_SAGA });
createRoot(document.getElementById("root")!).render(
  <Router>
    <StrictMode>
      <Provider store={store}>
          <div className="spfmvapp">
            <TextSizeApplier /> 
            <App />
          </div>
      </Provider>
    </StrictMode>
  </Router>
);
